import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NavService} from "../../../_services/_nav.service";
import {ConfirmationService} from "primeng/api";
import {Location} from "@angular/common";
import {CalendarioPropiedades} from "../../../_models/calendario-propiedades";
import {Producto} from "../../../_models/producto";
import {TasasVariablesCondicionesService} from "../../../_services/tasas-variables-condiciones.service";
import {TasasVariablesCondiciones} from "../../../_models/tasas-variables-condiciones";
import {TasasVariables} from "../../../_models/tasas-variables";
import {RolFuncionalitiesServices} from "../../../_services/rol-funcionalidad.service";
import {AutenticacionService} from "../../../_services/autenticacion.service";
import moment from 'moment';
import 'moment/locale/es';
import {DialogService} from "primeng/dynamicdialog";
import {DetalleTasaCondicionComponent} from "../modales/detalle-tasa-condicion/detalle-tasa-condicion.component";
import {forkJoin} from "rxjs";
import {AprobacionTasaComponent} from "../modales/aprobacion-tasa/aprobacion-tasa.component";
import {ListaService} from "../../../_services/lista.service";
import {ListaItem} from "../../../_models/lista-item";
import {
  TasasVariablesCondicionesNotificacionesService
} from "../../../_services/tasas-variables-condiciones-notificaciones.service";
import {EstadosTasasVariables, NotificacionesPushEnum} from '../../../_enums/enum';

@Component({
  selector: 'app-tasas-variables-editar-tasa',
  templateUrl: './tasas-variables-editar-tasa.component.html',
  styleUrls: ['./tasas-variables-editar-tasa.component.css']
})
export class TasasVariablesEditarTasaComponent implements OnInit {

  @Input() verDetalle: boolean = false;
  @Input() tasaVariable: TasasVariables;
  formulario: FormGroup;
  formularioCambioEstado: FormGroup;
  submitted: boolean = false;
  carInformacionInicial: boolean = true;
  guardando: boolean = false;
  hoy: Date;
  rango: any;
  calPropiedades: CalendarioPropiedades = new CalendarioPropiedades();
  listasasVarCon: TasasVariablesCondiciones[] = [];
  carTabla = true;
  columnas: any[];
  index = 0;
  botonVisibleEditar = false;
  botonVisibleAprobar = false;
  permitirFecha = true;
  listaEstados: ListaItem[] = [];
  showModalAprobacion: boolean = false;
  loadingModal: boolean = false;
  _dataTasaVariables: any = null;
  estadosTasasVaraibles = EstadosTasasVariables;
  submittedEstado: boolean = false;
  modalClose: boolean = false;
  numeroCaracteres: boolean = false;
  constructor(private fb: FormBuilder,
              private navService: NavService,
              private lisService: ListaService,
              private conServicio: ConfirmationService,
              private location: Location,
              private tasasVariablesCondicionesService: TasasVariablesCondicionesService,
              private authService: AutenticacionService,
              private diaService: DialogService,
              private rolFuncionalidadService: RolFuncionalitiesServices,
              private notificar: TasasVariablesCondicionesNotificacionesService) { }

  async ngOnInit() {
    forkJoin(this.rolFuncionalidadService.getByCodigoPadreCodigoHijo( 'ADTAVA', 'ADTAVA', 'CONTAS' ),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo( 'ADTAVA', 'ADTAVA', 'APRTAS' ),
      this.lisService.getMasterDetails( 'ListasEstadosFuncionalidades' ),).subscribe( ( [permisoCONTAS, permisoAPRTAS, listasEstadosFuncionalidades] ) => {
      this.botonVisibleEditar = !!permisoCONTAS.find( x => !!this.authService.obtenerRolesUsuarios().find( y => x.codigoRol === y ) );
      this.botonVisibleAprobar = !!permisoAPRTAS.find( x => !!this.authService.obtenerRolesUsuarios().find( y => x.codigoRol === y ) );
      this.listaEstados = listasEstadosFuncionalidades;
      this.hoy = new Date();
      const limite = this.hoy.getFullYear() + 50;
      this.rango = `${this.hoy.getFullYear()}:${limite}`;
      this.cargarFormulario();
      this.tasasVariablesCondicionesService.obtenerPorIdTasaVariableEnabled(this.tasaVariable.idTasaVariable).subscribe(res => {
        this.listasasVarCon = res;
        this.construirTabla();
      }, error => {
        this.construirTabla();
        this.navService.setMesage(0, {
          severity: 'error', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
          detail: this.navService.buscarMensaje('FABRICACREDITO.LBL_HAOCURRIDOERROR')
        });
      });
    })
  }

  construirTabla(){
    this.columnas = [
      { field: 'diasVigencia', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_DIASVIGENCIA'), sort: false },
      { field: 'fechaInicioVigencia', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_FECHAINICIO'), sort: true },
      { field: 'fechaFinVigencia', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_FECHAFIN'), sort: true },
      { field: 'valorTasa', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_VALOR'), sort: false },
      { field: 'estado', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_ESTADO'), sort: true },
      { field: 'usuarioConfigura', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_USUARIOCONFIGURA'), sort: false },
      { field: 'usuarioAprueba', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_USUARIOAPRUEBA'), sort: false },
      { field: 'fechaCreacion', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_FECHACREACION'), sort: true },
      { field: 'fechaAprobacion', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_FECHAAPROBACION'), sort: true },
      { field: 'observacion', header: this.navService.buscarMensaje('TASASVARIABLES.LBL_OBSERVACION'), sort: false },
      { field: 'acciones', header: this.navService.buscarMensaje('LBL_ACCIONES'), sort: false }
    ];
    this.carTabla = false;
    this.carInformacionInicial = false;
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idTasaVariable: [this.tasaVariable.idTasaVariable, []],
      idTasaVariableCondicion: [null, []],
      diasVigencia: [ null, [Validators.required]],
      fechaInicioVigencia: [ null, [Validators.required]],
      fechaFinVigencia: [{ value: null, disabled: true }, [Validators.required]],
      valorTasa: [ null, [Validators.required]],
    })
  }

  cargarFormularioCambioEstado() {
    this.formularioCambioEstado = this.fb.group({
      observacion: [ null, [Validators.required]]
    });
  }
  get f() {
    return this.formulario.controls;
  }

  get e() {
    return this.formularioCambioEstado.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.f.idTasaVariable.setValue(this.tasaVariable.idTasaVariable);
    if (this.formulario.valid && this.permitirFecha) {
      this.carTabla = true;
      this.guardando = true;
      if (this.f.idTasaVariableCondicion.value) {
        const realIndex = this.listasasVarCon.findIndex(
          x => x.idTasaVariableCondicion === this.f.idTasaVariableCondicion.value
        );

        if (realIndex === -1) return;

        for (const item of Object.keys(this.formulario.getRawValue())) {
          this.listasasVarCon[realIndex][item] = this.formulario.get(item).value;
        }
        const registro = this.listasasVarCon[realIndex];
        registro.fechaCreacion = null;
        registro.idUsuarioConfigura = this.authService.obtenerIdUsuarioLogueado();
        this.tasasVariablesCondicionesService.actualizar(registro).subscribe(res => {
          this.navService.setMesage( 0, {
            severity: 'success', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'TASASVARIABLES.MSG_REGACTU' )
          } );
          const listaIds = [];
          listaIds.push(res.idTasaVariableCondicion);
          const objeto = {ids: listaIds, codigoNotificacion: 'NOTCONTAS'};
          this.notificar.crear(objeto).subscribe(res => {});
          this.actualizarTabla();
        }, error => {
          this.carTabla = false;
          this.submitted = false;
          this.guardando = false;
          this.navService.setMesage(0, {
            severity: 'error', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
            detail: this.navService.buscarMensaje('FABRICACREDITO.LBL_HAOCURRIDOERROR')
          });
        });
      }else {
        const registro = this.formulario.value;
        const fi = moment(this.f.fechaInicioVigencia.value).format('YYYY-MM-DD');
        const ff = moment(this.f.fechaFinVigencia.value).format('YYYY-MM-DD');
        const fechaInicio = new Date(fi + 'T00:00:00');
        const fechaFin = new Date(ff + 'T00:00:00');
        registro.fechaInicioVigencia = fechaInicio;
        registro.fechaFinVigencia = fechaFin;
        registro.idUsuarioConfigura = this.authService.obtenerIdUsuarioLogueado();
        this.tasasVariablesCondicionesService.crear(registro).subscribe(res => {
          this.navService.setMesage( 0, {
            severity: 'success', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'TASASVARIABLES.MSG_REGAGG' )
          } );
          const listaIds = [];
          listaIds.push(res.idTasaVariableCondicion);
          const objeto = {ids: listaIds, codigoNotificacion: 'NOTCONTAS'};
          this.notificar.crear(objeto).subscribe(res => {});
          this.actualizarTabla();
        }, error => {
          this.carTabla = false;
          this.submitted = false;
          this.guardando = false;
          this.navService.setMesage(0, {
            severity: 'error', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
            detail: this.navService.buscarMensaje('FABRICACREDITO.LBL_HAOCURRIDOERROR')
          });
        });
      }
    }
  }

  actualizarTabla(){
    this.submitted = false;
    this.tasasVariablesCondicionesService.obtenerPorIdTasaVariableEnabled(this.tasaVariable.idTasaVariable).subscribe(res => {
      this.listasasVarCon = res;
      this.guardando = false;
      this.carTabla = false;
      this.formulario.reset();
    });
  }

  calcularFechaFin(){
    if(this.f.fechaInicioVigencia.value && this.f.diasVigencia.value && this.f.diasVigencia.value>0) {
      const calculo = new Date(this.f.fechaInicioVigencia.value);
      calculo.setDate(calculo.getDate() + Number(this.f.diasVigencia.value) - 1);
      this.f.fechaFinVigencia.setValue(calculo);
      this.permitirFecha = true;
      this.validarFechas();
    } else {
      this.f.fechaFinVigencia.setValue(null);
      this.permitirFecha = true;
    }
  }

  validarFechas() {
    if (this.listasasVarCon.length > 0) {
      let lista = this.listasasVarCon.filter(x => x.codigoEstado === this.estadosTasasVaraibles.CNFACT || x.codigoEstado === this.estadosTasasVaraibles.CNFPEN || x.codigoEstado === this.estadosTasasVaraibles.CNFAPR);
      if (this.f.idTasaVariableCondicion.value) {
        lista = lista.filter(x => x.idTasaVariableCondicion !== this.f.idTasaVariableCondicion.value);
      }
      const fi = moment(this.f.fechaInicioVigencia.value).format('YYYY-MM-DD');
      const ff = moment(this.f.fechaFinVigencia.value).format('YYYY-MM-DD');
      const fechaInicio = new Date(fi + 'T00:00:00');
      const fechaFin = new Date(ff + 'T00:00:00');
      lista.map(e => {
        const fechaFinComparar = new Date(e.fechaFinVigencia + 'T00:00:00');
        const fechaInicioComparar = new Date(e.fechaInicioVigencia + 'T00:00:00');
          if (fechaInicio.getTime() <= fechaFinComparar.getTime() && fechaInicio.getTime() >= fechaInicioComparar.getTime()) {
            this.permitirFecha = false;
          } else if (fechaFin.getTime() >= fechaInicioComparar.getTime() && fechaFin.getTime() <= fechaFinComparar.getTime()) {
            this.permitirFecha = false;
          }
      });
    }
  }

  editar(dato: any) {
    this.f.idTasaVariableCondicion.setValue(dato.idTasaVariableCondicion);
    this.f.diasVigencia.setValue(dato.diasVigencia);
    this.f.fechaInicioVigencia.setValue(new Date(dato.fechaInicioVigencia + 'T00:00:00'));
    this.f.fechaFinVigencia.setValue(new Date(dato.fechaFinVigencia + 'T00:00:00'));
    this.f.valorTasa.setValue(dato.valorTasa);
    this.permitirFecha = true;
  }

  aprobarDenegarTasa(dato: any){
    if (!dato.indicadorInactivar) {
      const modal = this.diaService.open(AprobacionTasaComponent, {
        header: this.navService.buscarMensaje('TASASVARIABLES.LBL_APROBACIONTASA'),
        width: '40%',
        closeOnEscape: true,
        closable: true,
        styleClass: 'testDialog title-green',
        data: {
          registro: dato,
          lisEstados: this.listaEstados,
          lisRegistros: this.listasasVarCon
        }
      });
      modal.onClose.subscribe((data: any) => {
        if (data) {
          this.carTabla = true;
          this.actualizarTabla();
        }
      });
    } else {
      this.activarModalTasas(dato);
    }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
  }

  visualizar(dato: any){
    this.diaService.open( DetalleTasaCondicionComponent, {
      header: this.navService.buscarMensaje( 'TASASVARIABLES.LBL_APROBACIONTASA' ),
      width: '60%',
      closeOnEscape: true,
      closable: true,
      styleClass: 'testDialog title-green',
      data: {
        registro: dato
      }
    } )
  }

  activarModalTasas(_reg: any) {
    this.loadingModal = true;
    this._dataTasaVariables = _reg;
    this.modalClose = this._dataTasaVariables.indicadorInactivar;
    this._dataTasaVariables.titulo = _reg.indicadorInactivar ? this.navService.buscarMensaje( 'TASASVARIABLES.LBL_APROBACIONTASA' ) :  this.navService.buscarMensaje( 'TASASVARIABLES.TITULOINACTIVACION' );
    this.cargarFormularioCambioEstado();
    this.showModalAprobacion = true;
    this.loadingModal = false;
  }

  cerrarModalEstados() {
    this.showModalAprobacion = false;
    this.modalClose = false;
    this.loadingModal = false;
    this.submittedEstado = false;
    this.e.observacion.setValue(null);
  }

  onSubmitCambioEstado() {
    this.submittedEstado = true;
    this.numeroCaracteres = false;
    if (this.formularioCambioEstado.valid) {
     if ( this.e.observacion.value.length < 50) {
       this.numeroCaracteres = true;
       return;
     }

      this.showModalAprobacion = false;
      this.loadingModal = true;
      this._dataTasaVariables.indicadorInactivar = true;
      this._dataTasaVariables.observacion = this.e.observacion.value;
      this.tasasVariablesCondicionesService.actualizar(this._dataTasaVariables).subscribe(async regAct => {
        const _indice = this.listasasVarCon.findIndex( sa => sa.idTasaVariableCondicion === this._dataTasaVariables.idTasaVariableCondicion );
        this.showModalAprobacion = false;
        if (_indice !== -1) {
          this.listasasVarCon[_indice].observacion = this.e.observacion.value;
          this.listasasVarCon[_indice].indicadorInactivar = true;
        }
        const objetoNoti = {ids: [this._dataTasaVariables.idTasaVariableCondicion], codigoNotificacion: NotificacionesPushEnum.NOTDETAS};
        await this.notificar.crear(objetoNoti).toPromise();
        this.cerrarModalEstados();
        this.navService.setMesage( 2);
      }, error => {
        this.navService.setMesage( 3 );
        this.loadingModal = false;
      });
    }
  }

  cambioEstadoTasa(indicadorAprobar: boolean = false) {
    this.showModalAprobacion = false;
    this._dataTasaVariables.indicadorInactivar = false;
    let _estado = null;
    if (indicadorAprobar) {
     _estado =  this.listaEstados.find(x => x.codigo === EstadosTasasVariables.CNFINA);
     if (_estado) {
       this._dataTasaVariables.idEstadoFuncionalidad = _estado.idLista;
     }
    }
    this.tasasVariablesCondicionesService.actualizar(this._dataTasaVariables).subscribe(async regAct => {
      const _indice = this.listasasVarCon.findIndex( sa => sa.idTasaVariableCondicion === this._dataTasaVariables.idTasaVariableCondicion );
      if (_indice !== -1) {
        this.listasasVarCon[_indice].indicadorInactivar = false;
        if (indicadorAprobar) {
          if (_estado && _estado.idLista) {
            this.listasasVarCon[_indice].idEstadoFuncionalidad = _estado.idLista;
            this.listasasVarCon[_indice].estado = _estado.nombre;
            this.listasasVarCon[_indice].codigoEstado = _estado.codigo;

          }
        }
      }
      const objetoNoti = {ids: [this._dataTasaVariables.idTasaVariableCondicion], codigoNotificacion: NotificacionesPushEnum.NOTTASINA};
      await this.notificar.crear(objetoNoti).toPromise();
      this.cerrarModalEstados();
      this.navService.setMesage( 2);
    }, error => {
      this.navService.setMesage( 3 );
      this.loadingModal = false;
    });
  }


}
